import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import EcosystemLayout from './components/layout/EcosystemLayout';
import FunnelLayout from './components/layout/FunnelLayout';
import Home from './pages/Home';
import ClarityGuide from './pages/ClarityGuide';
import Blueprint from './pages/Blueprint';
import Thrive from './pages/Thrive';
import About from './pages/About';
import Speaking from './pages/Speaking';
import ThankYou from './pages/ThankYou';
import Resources from './pages/Resources';
import Services from './pages/Services';
import Training from './pages/Training';
import Contact from './pages/Contact';
import Placeholder from './pages/Placeholder';

function App() {
  return (
    <HashRouter>
      <Routes>
        {/* Ecosystem Routes */}
        <Route path="/" element={<EcosystemLayout><Home /></EcosystemLayout>} />
        <Route path="/about" element={<EcosystemLayout><About /></EcosystemLayout>} />
        <Route path="/speaking" element={<EcosystemLayout><Speaking /></EcosystemLayout>} />
        <Route path="/services" element={<EcosystemLayout><Services /></EcosystemLayout>} />
        <Route path="/training" element={<EcosystemLayout><Training /></EcosystemLayout>} />
        <Route path="/blueprint" element={<EcosystemLayout><Blueprint /></EcosystemLayout>} />
        <Route path="/thrive" element={<EcosystemLayout><Thrive /></EcosystemLayout>} />
        <Route path="/resources" element={<EcosystemLayout><Resources /></EcosystemLayout>} />
        <Route path="/contact" element={<EcosystemLayout><Contact /></EcosystemLayout>} />
        <Route path="/privacy" element={<EcosystemLayout><Placeholder title="Privacy Policy" /></EcosystemLayout>} />
        <Route path="/terms" element={<EcosystemLayout><Placeholder title="Terms of Service" /></EcosystemLayout>} />

        {/* Funnel Routes */}
        <Route path="/clarity-guide" element={<FunnelLayout><ClarityGuide /></FunnelLayout>} />
        <Route path="/thank-you" element={<FunnelLayout><ThankYou /></FunnelLayout>} />
      </Routes>
    </HashRouter>
  );
}

export default App;